import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getStatesRequest: [],
  getStatesSuccess: ['data'],
  getStatesFailure: [],
});

export const StatesTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  loading: false,
  data: [],
  error: false,
});

/* Reducers */

const getStatesRequest = (state) => state.merge({
  ...state,
  loading: true,
});

const getStatesSuccess = (state, { data }) => state.merge({
  data,
  loading: false,
  error: false,
});

const getStatesFailure = (state) => state.merge({
  ...state,
  error: true,
  loading: false,
});

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_STATES_REQUEST]: getStatesRequest,
  [Types.GET_STATES_SUCCESS]: getStatesSuccess,
  [Types.GET_STATES_FAILURE]: getStatesFailure,
});
